import { Pipe, PipeTransform } from '@angular/core';
import { ApiService } from 'src/app/core/http/api.service';

@Pipe({
  name: 'currencyFormat',
})
export class CurrencyFormatPipe implements PipeTransform {
  public currencyCode = '';
  public currencySymbol = '';
  constructor(private api: ApiService) {}

  transform(amountLabel: any, args?: any) {
    // const amount = parseInt(amountLabel);
    if (args.credit) {
      const formattedAmount = this.formatAmount(
        amountLabel,
        args.currencyRegional
      );
      return formattedAmount;
    } else if (args.isNumber) {
      const formattedAmount = this.formatAmount(
        amountLabel,
        args.currencyRegional,
        true
      );

      return formattedAmount;
    } else {
      const formattedAmount = this.formatAmount(
        amountLabel,
        args.currencyRegional
      );
      return `${args.currencySymbol} ${formattedAmount} ${args.currencyCode}`;
    }
  }

  formatAmount(amount: number, regional: string, isNumber?: boolean): string {
    if (amount === 0) {
      if (isNumber) {
        return '0';
      } else {
        return amount.toLocaleString(regional, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      }
    }

    if (isNumber) {
      return amount.toLocaleString(regional, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
    }

    if (amount && regional) {
      return amount.toLocaleString(regional, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    }

    return '';
  }
}
